// $FlowFixMe
/* eslint-disable flowtype/no-types-missing-file-annotation */

import * as React from 'react';
import { css } from 'glamor';
import { withNamespaces } from 'react-i18next';

import { tryLogin } from './actions';
import { getRateLimitEndTime, setRateLimitEndTime } from '../../utils/storage';

const RATE_LIMIT_DURATION = 60 * 1000;

type Props = {
  onSubmit?: State => void,
  signInUrl: string,
  urlBuilder: any => string,
  t: (string, any) => string
}

type State = {
  username: string,
  password: string,
  errorMessage: string,
  rateLimitTimeRemaining: number,
}

export class Form extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      username: '',
      password: '',
      errorMessage: '',
      rateLimitTimeRemaining: 0,
    };
  }


  componentDidMount() {
    const endTime = getRateLimitEndTime();
    if (endTime) {
      this.startRateLimitTimer(endTime);
    }
  }

  handleInputChange = (e: SyntheticInputEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  handleSubmit = (e: Event) => {
    e.preventDefault();
    const { signInUrl, urlBuilder, onSubmit } = this.props;
    const { username, password } = this.state;
    if (onSubmit) {
      onSubmit(this.state);
    }
    tryLogin(signInUrl, username, password, urlBuilder)
      .catch((err) => {
        if (err && err.statusCode === 429) {
          const rateLimitEndTime = new Date((new Date()).getTime() + RATE_LIMIT_DURATION).getTime();
          setRateLimitEndTime(rateLimitEndTime);
          this.startRateLimitTimer(rateLimitEndTime);
          return;
        }
        this.setState({
          errorMessage: err.message,
        });
      });
  };

  startRateLimitTimer = (rateLimitEndTime: number) => {
    this.setState({
      rateLimitTimeRemaining: Math.ceil((rateLimitEndTime - new Date()) / 1000),
    });
    const timerId = setInterval(() => {
      const timeRemaining = Math.ceil((rateLimitEndTime - new Date()) / 1000);
      if (timeRemaining <= 0) {
        clearInterval(timerId);
      }
      this.setState({
        rateLimitTimeRemaining: timeRemaining,
      });
    }, 1000);
  }

  render(): React.Node {
    const { errorMessage, rateLimitTimeRemaining } = this.state;
    const { t } = this.props;
    return (
      <div className={`modal-body ${styles}`}>
        <form onSubmit={this.handleSubmit}>
          <div className="login-fields">
            <div className="modal-input">
              <label htmlFor="username">{t('App.Label.Email', 'Email')}</label>
              <input type="email" name="username" id="username" onChange={this.handleInputChange} required />
            </div>
            <div className="modal-input">
              <label htmlFor="password">{t('App.Label.Password', 'Password')}</label>
              <input type="password" name="password" id="password" onChange={this.handleInputChange} required />
            </div>
            {errorMessage && (
            <div className="error-message">
              {errorMessage}
            </div>
            )}
            {rateLimitTimeRemaining > 0 ? (
              <div className="error-message">
                {t('App.LoginForm.TooManyAttempts', {
                  defaultValue: 'Too many unsuccessful attempts to sign in. Please try resetting your password or you can try again in {{timeRemaining}} seconds.',
                  timeRemaining: rateLimitTimeRemaining,
                })}
              </div>
            ) : ''}
            <button type="submit" className="submit" disabled={rateLimitTimeRemaining > 0}>
              <span>{t('App.Button.SignInWithEmail', 'Sign In with Email')}</span>
            </button>
          </div>
        </form>
      </div>
    );
  }
}

export default withNamespaces()(Form);

const styles = css({
  ' .login-fields': {
    display: 'flex',
    maxWidth: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',
    flexDirection: 'column',
    ' .modal-input': {
      margin: '10px 0 20px',
      ' label': {
        margin: '0 0 10px',
        display: 'inline-block',
      },
      ' input': {
        color: 'rgb(28, 28, 28)',
        boxShadow: 'rgba(28, 28, 28, 0.3) 0 0 3px 0 inset',
        WebkitAppearance: 'none',
        fontSize: '14px',
        lineHeight: '21px',
        textIndent: '15px',
        height: '45px',
        width: '100%',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'rgba(255, 255, 255, 0.2)',
        borderImage: 'initial',
        padding: 0,
      },
    },
    ' .error-message': {
      fontSize: '12px',
      lineHeight: '18px',
      color: 'rgb(238, 40, 40)',
      textAlign: 'left',
      width: '100%',
      margin: '-10px 0 15px',
    },
    ' .submit': {
      backgroundColor: 'rgb(250, 70, 22)',
      color: 'rgb(255, 255, 255)',
      borderColor: 'rgb(250, 70, 22)',
      borderWidth: 0,
      lineHeight: '44px',
      height: '44px',
      padding: '0 15px',
      outline: 'none',
      fontFamily: '\'Qanelas\', sans-serif',
      fontWeight: 'bold',
      fontSize: '14px',
      textTransform: 'uppercase',
      display: 'inline-flex',
      cursor: 'pointer',
      alignItems: 'center',
      justifyContent: 'center',
      margin: 0,
      borderRadius: '1px',
      borderStyle: 'solid',
      flexFlow: 'row nowrap',
      boxShadow: 'rgba(28, 28, 28, 0.2) 0 0 10px 0, rgba(28, 28, 28, 0.15) 0 1px 3px 0',
      ':disabled': {
        opacity: 0.5,
      },
    },
  },
});
